import { dbService } from './db';
import { useSubmit, useFetcher, useOutletContext } from "react-router";
// import { useOutletContext } from 'react-router-dom'
import { Button } from '@headlessui/react'
import clsx from 'clsx'

export function meta({ }) {
  return [
    { title: "DX Sales App - Setup" },
    { name: "description", content: "Welcome to DX Sales App - Setup" },
  ];
}

export async function clientLoader({ }) {
  let db = await dbService.createDB();
  let customers = (await db.getAll("customers"));
  return { customers };
}

export function Setup() {

  const { activeAccount } = useOutletContext();
  let fetcher = useFetcher();
  let busy = fetcher.state !== "idle";
  let submit = useSubmit();

  return (
    <>
      <h1 className="text-lg">Setup</h1>

      <Button onClick={() => {
        submit(
          { token: activeAccount.idToken, serverVal: "true" },
          { action: "/setup", method: "post" }
        );
      }} className="bg-gray-800 block rounded p-3.5 items-center justify-center text-gray-100 mt-2 mb-16">{busy ? "Syncing..." : "Sync"}</Button>

      <Button onClick={() => {
        submit(
          { token: activeAccount.idToken, serverVal: "false" },
          { action: "/setup", method: "post" }
        );
      }} className="bg-gray-800 block rounded p-3.5 items-center justify-center text-gray-100 mt-2 mb-16">{busy ? "Syncing..." : "Populate app"}</Button>

    </>
  );
}

export async function callSync(request) {
  let formData = await request.formData();
  let serverVal = formData.get("serverVal");

  if (serverVal === "true") {
    let res = await fetch(`/sync`, {
      headers: {
        'Token': formData.get("token")
      },
      method: "POST"
    });
  } else {
    console.log("populating app")
    let res = await fetch(`/api/shipments`, {
      headers: {
        'Token': formData.get("token")
      }
    });
    let db = await dbService.createDB();
    res.json().then(async (shipments) => {
      shipments.forEach(async (shipment) => {
        await db.put("shipments", shipment);
      });
    })
  }
}